<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'sites' }"
          >Sites</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="display-2 font-weight-bold my-6 ml-4 text-capitalize">
      {{ form.name }}
    </div>

    <div class="d-flex ml-4 my-5">
      <!-- <v-btn
        color="light-blue"
        class="white--text"
        depressed
        @click="assignDialog = true"
      >
        Assign New Sparkies
      </v-btn> -->

      <v-btn
        color="light-blue"
        class="white--text ml-3"
        depressed
        @click="siteMapDialog = true"
      >
        View Site Map
      </v-btn>
    </div>

    <!-- <assign-new-sparkies
      v-model="assignDialog"
      @closeModal="assignDialog = false"
    /> -->

    <view-site-map
      v-model="siteMapDialog"
      @closeModal="siteMapDialog = false"
    />

    <site-banner @change="onChangeImage" />
    <div
      class="ml-5 v-messages theme--light error--text"
      v-if="form.$getError('banner')"
    >
      {{ form.$getError('banner')[0] }}
    </div>

    <div class="ma-4" v-if="form">
      <div class="d-flex my-6">
        <v-form
          ref="formUpdateSite"
          v-if="form"
          style="width: 400px"
          enctype="multipart/form-data"
        >
          <label class="text-field-label">Name</label>
          <v-text-field
            flat
            solo
            required
            class="mt-2"
            v-model="form.name"
            :error-messages="form.$getError('name')"
            :loading="loading"
            :rules="[rules.required]"
          ></v-text-field>

          <label class="text-field-label">Address</label>
          <place-autocomplete
            v-model="form.address"
            name="location"
            :api-key="$env.placesApiKey"
            :input-state="null"
            :input-error="form.$getError('address')"
            input-class="ellipsis w-100"
          ></place-autocomplete>

          <div class="mt-5 d-flex justify-space-between">
            <v-btn
              color="red"
              dark
              depressed
              class="px-6"
              height="40px"
              @click="deleteDialog = true"
              :loading="form.$busy"
              >Delete</v-btn
            >
            <v-btn
              color="primary"
              depressed
              class="px-6"
              height="40px"
              @click="updateSiteDetails"
              :loading="form.$busy"
              >Update</v-btn
            >
          </div>
        </v-form>

        <v-dialog v-model="deleteDialog" max-width="320">
          <v-card>
            <v-card-title class="headline">Confirm Delete</v-card-title>

            <v-card-text
              >Are you sure you want to delete this site?</v-card-text
            >
            <v-card-actions>
              <v-btn text @click="deleteDialog = false" :loading="form.$busy"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="deleteSite" :loading="form.$busy"
                >Yes, Delete please</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      <div class="d-flex justify-space-between">
        <div class="mt-2 ml-3">{{ snackbar.message }}</div>
        <div class="text-right">
          <v-btn text @click="snackbar.show = false">OK</v-btn>
        </div>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import {
  mdiChevronLeft,
  mdiCheck,
  mdiAlertCircleOutline,
  mdiAccountMultiplePlus,
  mdiMapMarker
} from '@mdi/js'
import { mapState, mapActions, mapMutations } from 'vuex'
import Compressor from 'compressorjs'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import SiteBanner from '@/components/photos/SiteBanner'
import PlaceAutocomplete from '@/components/autocomplete/PlaceAutocomplete'
// import AssignNewSparkies from '@/components/modals/AssignNewSparkies'
import ViewSiteMap from '@/components/modals/ViewSiteMap'
import Form from '@/utils/form'

export default {
  name: 'SiteDetails',

  components: {
    AppBarNavIcon,
    SiteBanner,
    PlaceAutocomplete,
    // AssignNewSparkies,
    ViewSiteMap
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        check: mdiCheck,
        alert: mdiAlertCircleOutline,
        plus: mdiAccountMultiplePlus,
        map: mdiMapMarker
      },
      loading: false,
      deleteDialog: false,
      assignDialog: false,
      siteMapDialog: false,
      imageChanged: false,
      form: new Form({
        name: '',
        address: '',
        banner: ''
      }),
      showCropperModal: false,
      tabItems: [{ tab: 'Info' }, { tab: 'Chats' }],
      rules: {
        required: value => !!value || 'This field is required.'
      },
      snackbar: {
        show: false,
        message: '',
        color: ''
      }
    }
  },

  computed: {
    ...mapState({
      site: state => state.site.siteDetails,
      authSite: state => state.auth.site
    })
  },

  methods: {
    ...mapActions({
      getSiteDetails: 'site/getSiteDetails',
      updateSite: 'site/updateSite'
    }),

    ...mapMutations({
      clearSiteDetails: 'site/clearSiteDetails'
    }),

    onChangeImage(blob) {
      this.imageChanged = true
      if (blob.size < 1000000) {
        this.form.$clearErrors()

        let _this = this
        // eslint-disable-next-line
        new Compressor(blob, {
          quality: 0.2,
          success(result) {
            _this.form.banner = result
          }
        })
      } else {
        this.form.$setErrors({ banner: ['Image size is too large'] })
      }
    },

    async getSite() {
      this.loading = true
      await this.getSiteDetails(this.$route.params.id)
      this.form = new Form(this.site)
      this.loading = false
    },

    async updateSiteDetails() {
      if (
        this.$refs.formUpdateSite.validate() &&
        !this.form.$getError('banner')
      ) {
        this.form.$busy = true
        this.form.$clearErrors()

        let data = new FormData()
        data.append('site_id', this.form.site_id)
        if (this.form.name) {
          data.append('name', this.form.name)
        }
        if (this.form.address) {
          data.append('address', this.form.address)
        }
        if (this.imageChanged) {
          data.append('banner', this.form.banner)
        }

        this.updateSite(data)
          .then(() => {
            this.form.$busy = false
            this.imageChanged = false
            this.showSnackbar('Site details successfully updated!', 'success')
          })
          .catch(err => {
            this.form.$busy = false
            if (err.response.status === 422) {
              this.form.$setErrors(err.response.data.errors)
            }
          })
      }
    },

    deleteSite() {
      this.form.$busy = true
      this.site.delete().then(() => {
        this.form.$busy = false
        this.deleteDialog = false
        this.showSnackbar('Site deleted successfully!')
        this.$router.replace('/sites')
      })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  },

  created() {
    this.getSite()
  },

  destroyed() {
    this.clearSiteDetails()
  },

  watch: {
    $route() {
      this.getSite()
    }
  }
}
</script>
